import { cn } from '@/lib/utils'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface ThoughtBubbleProps {
  content: string
  className?: string
}

export function ThoughtBubble({ content, className }: ThoughtBubbleProps) {
  // Extract content between <think> tags
  const thoughtMatch = content.match(/<think>([\s\S]*?)<\/think>/)
  if (!thoughtMatch) return null

  const thoughtContent = thoughtMatch[1].trim()

  return (
    <div
      className={cn(
        "relative p-4 rounded-xl shadow-md group",
        "transition-all duration-200 ease-in-out",
        "bg-white/50 dark:bg-gray-800/50 backdrop-blur-md",
        "border border-gray-200/50 dark:border-gray-700/50",
        "before:content-[''] before:absolute before:left-4 before:-top-2",
        "before:w-4 before:h-4 before:rotate-45",
        "before:bg-white/50 dark:before:bg-gray-800/50 before:backdrop-blur-md",
        "before:border-t before:border-l",
        "before:border-gray-200/50 dark:before:border-gray-700/50",
        "hover:shadow-lg hover:scale-[1.01]",
        className
      )}
      style={{
        backgroundImage: "linear-gradient(to bottom right, rgba(0,0,0,0.02), rgba(0,0,0,0.02))",
        backgroundBlendMode: "soft-light",
      }}
    >
      <div 
        className="absolute inset-0 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-200"
        style={{
          backgroundImage: "radial-gradient(circle at top left, rgba(56,189,248,0.1), rgba(99,102,241,0.1))",
          backgroundBlendMode: "soft-light",
        }}
      />
      <div className="prose prose-sm dark:prose-invert max-w-none relative">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>
          {thoughtContent}
        </ReactMarkdown>
      </div>
    </div>
  )
}
